import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { DynamicSelect } from "../../components/DynamicSelect";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadePriorizacao = ({
    tipoPrioridadeList,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [itemsAutocomplete, setItemsAutocomplete] = useState([]);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [observacao, setObservacao] = useState("");
    var [tipoPrioridade, setTipoPrioridade] = useState(null);
    var [idTipoPrioridade, setIdTipoPrioridade] = useState(null);

    const COR_SINALIZADORES = {
        0: "",
        1: "#10B981",
        2: "#f7cc4d",
        3: "#f16262",
        4: "#aa0505",
    };

    const style = {
        content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)',
            borderRadius: "0px", minWidth: '35%', overflowY: 'auto',
            minHeight: '45%', maxHeight: '90%'
        },
        overlay: { zIndex: 9999 }
    };

    const searchStyling = {
        height: "44px",
        border: "1px solid #dfe1e5",
        borderRadius: "4px",
        backgroundColor: "white",
        boxShadow: "none",
        hoverBackgroundColor: "#eee",
        color: "#212121",
        fontSize: "16px",
        fontFamily: "inherit",
        iconColor: "grey",
        lineColor: "rgb(232, 234, 237)",
        placeholderColor: "grey",
        clearIconMargin: "3px 14px 0 0",
        searchIconMargin: "0 0 0 16px"
    };

    const closeModal = () => {
        setisLoading(false);
        setItemsAutocomplete([]);
        setItemSelecionado(null);
        setIdTipoPrioridade(null);
        setTipoPrioridade(null);
        setObservacao("");
        setIsOpen(false);
    }

    const handleOnSearch = async (string, results) => {
        if (!string || string.length === 0) {
            setItemsAutocomplete([]);
            return;
        }

        try {
            const response = await api.get(`Visibilidade/list/priorizacao?search=${string}`);

            // O componente exige um array com propriedade 'name' para exibir na lista
            // Vamos mapear seus dados para esse formato
            const dadosFormatados = (response.data?.data?.itens || response.data || []).map(item => ({
                ...item,
                // O 'name' é o que aparece na lista suspensa
                name: `${item.processoSigla} - ${item.cliente} (${item.segurado})`
            }));

            setItemsAutocomplete(dadosFormatados);
        } catch (error) {
            console.error("Erro na busca", error);
            setItemsAutocomplete([]);
        }
    };

    const handleOnSelect = (item) => {
        setItemSelecionado(item);
    };

    const handleOnClear = () => {
        setItemSelecionado(null);
    };

    const getTipoPrioridade = (currentValue, value) => {
        if (!value) {
            setTipoPrioridade(null);
            setIdTipoPrioridade(null);
            return;
        }

        var tipoPrioridadeResult = tipoPrioridadeList.filter(function (o) {
            return o.key == value;
        });
        tipoPrioridade = tipoPrioridadeResult[0].value;
        idTipoPrioridade = tipoPrioridadeResult[0].key;
        setTipoPrioridade(tipoPrioridade);
        setIdTipoPrioridade(idTipoPrioridade);
    };

    const onPriorizar = () => {
        //if (!etapa) { campoObrigatorio("Você precisa escolher uma Etapa"); return false; }

        Swal.fire({
            html: `Deseja Priorizar o Processo <strong>${itemSelecionado.processoSigla}</strong>?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };
                    const dados = {
                        idTipoPrioridade: idTipoPrioridade,
                        idTipoServico: itemSelecionado.idTipoServico,
                        observacao: observacao,
                    };

                    console.log('dados', dados);
                    await api.post(`Visibilidade/priorizar/${itemSelecionado.idProcesso}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Processo Priorizado com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        setItemsAutocomplete([]);
                        setItemSelecionado(null);
                        setIdTipoPrioridade(null);
                        setTipoPrioridade(null);
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(itemSelecionado.idProcesso, itemSelecionado.idTipoServico);
                        }
                    });

                } catch (err) { setisLoading(false); }
            } else {
                setisLoading(false);
            }
        });
    };

    const onDespriorizar = () => {
        Swal.fire({
            html: `Deseja Despriorizado o Processo <strong>${itemSelecionado.processoSigla}</strong>?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };
                    const dados = {
                        idTipoPrioridade: null,
                        idTipoServico: itemSelecionado.idTipoServico,
                        observacao: observacao,
                    };

                    console.log('dados', dados);
                    await api.post(`Visibilidade/despriorizar/${itemSelecionado.idProcesso}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Processo Despriorizado com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        setItemsAutocomplete([]);
                        setItemSelecionado(null);
                        setIdTipoPrioridade(null);
                        setTipoPrioridade(null);
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(itemSelecionado.idProcesso, itemSelecionado.idTipoServico);
                        }
                    });

                } catch (err) { setisLoading(false); }
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            setItemsAutocomplete([]);
            setItemSelecionado(null);
            setIdTipoPrioridade(null);
            setTipoPrioridade(null);
            setObservacao("");
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Priorização"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M160.5-26.4c9.3-7.8 23-7.5 31.9 .9 12.3 11.6 23.3 24.4 33.9 37.4 13.5 16.5 29.7 38.3 45.3 64.2 5.2-6.8 10-12.8 14.2-17.9 1.1-1.3 2.2-2.7 3.3-4.1 7.9-9.8 17.7-22.1 30.8-22.1 13.4 0 22.8 11.9 30.8 22.1 1.3 1.7 2.6 3.3 3.9 4.8 10.3 12.4 24 30.3 37.7 52.4 27.2 43.9 55.6 106.4 55.6 176.6 0 123.7-100.3 224-224 224S0 411.7 0 288c0-91.1 41.1-170 80.5-225 19.9-27.7 39.7-49.9 54.6-65.1 8.2-8.4 16.5-16.7 25.5-24.2zM225.7 416c25.3 0 47.7-7 68.8-21 42.1-29.4 53.4-88.2 28.1-134.4-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5-17.3-22.1-49.1-62.4-65.3-83-5.4-6.9-15.2-8-21.5-1.9-18.3 17.8-51.5 56.8-51.5 104.3 0 68.6 50.6 109.2 113.7 109.2z" /></svg>
                                    Priorização</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                {isLoading ? (
                    <div className="text-center"><div className="spinner-border text-danger"></div></div>
                ) : (
                    <>
                        <div className="row justify-content-center mb-3">
                            <div className="col-12 mb-2" style={{ zIndex: 1000 }}> {/* zIndex alto para o autocomplete flutuar sobre tudo */}
                                <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>Pesquisar Processo</label>
                                <ReactSearchAutocomplete
                                    key={"visibilidade-autocomplete-priorizacao"}
                                    items={itemsAutocomplete}
                                    onSearch={handleOnSearch}
                                    onSelect={handleOnSelect}
                                    onClear={handleOnClear}
                                    autoFocus
                                    placeholder="Digite Sigla, Cliente ou Segurado..."
                                    styling={searchStyling}
                                    fuseOptions={{ keys: ["name"], threshold: 1, minMatchCharLength: 0 }}
                                    resultStringKeyName="name"
                                />
                            </div>
                        </div>

                        {/* Exibe informações APÓS selecionar, fixo na tela (não flutuante) */}
                        {itemSelecionado && (
                            <>
                                <div className="row mb-2" style={{ fontSize: "14px" }}>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br />{itemSelecionado.processoSigla || "-"}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br />{itemSelecionado.liderProcesso || "-"}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br />{itemSelecionado.cliente || "-"}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br />{itemSelecionado.segurado || "-"}</div>
                                </div>
                                <div className="row" style={{ fontSize: "14px" }}>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br />{itemSelecionado.disciplina}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Abertura</span><br />{new Date(itemSelecionado.dataAbertura).toLocaleDateString('pt-BR')}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Prioridade Atual</span><br />{itemSelecionado.prioridade ? itemSelecionado.prioridade : '-'}</div>
                                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Sinalização</span><br /><span style={{ color: COR_SINALIZADORES[itemSelecionado.tipoSinalizacao.idTipoSinalizacao || 0] }}>{itemSelecionado.tipoSinalizacao.tipoSinalizacaoDescricao || '-'}</span></div>
                                </div>
                                <div className="modal-divider" style={{ opacity: "0.3" }}><hr /></div>

                                <div className="row align-items-center justify-content-center mt-3">
                                    <div className="col-12 text-center mb-2">
                                        <DynamicSelect 
                                            key={"visibilidade-dynamic-select-prioridade"} 
                                            placeholder={''} 
                                            valuetext={tipoPrioridade} 
                                            label={'Tipo Prioridade'} 
                                            name={'idTipoPrioridade'} 
                                            options={tipoPrioridadeList} 
                                            keyValue={'key'} 
                                            keyLabel={'value'} 
                                            clearOption={true} 
                                            paramMethod={getTipoPrioridade} />
                                    </div>
                                </div>

                                <div className="row align-items-center justify-content-center">
                                    <div className="col text-center">
                                        <DynamicTextareaOnChange
                                            key={"visibilidade-dynamic-textarea-observacoes"}
                                            placeholder={"Observações"}
                                            label={"Observações"}
                                            name={"observacao"}
                                            valuetext={observacao}
                                            onChange={(e) => setObservacao(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="modal-divider" style={{ opacity: "0.3" }}><hr /></div>

                        <Flex>
                            <Flex.Item>
                                <div className="row align-items-center justify-content-center">
                                    <div className="col text-center">
                                        <input
                                            key={"visibilidade-input-priorizar"}
                                            className='default-button-blue'
                                            value={'Priorizar'}
                                            type="button"
                                            onClick={onPriorizar}
                                        />
                                    </div>
                                    {itemSelecionado?.prioridade && (
                                        <div className="col text-center">
                                            <input
                                                key={"visibilidade-input-despriorizar"}
                                                className='default-button-red'
                                                value={'Despriorizar'}
                                                type="button"
                                                onClick={onDespriorizar}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Flex.Item>
                        </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};